import { render } from "./rbs-information.vue?vue&type=template&id=a9884d26"
import script from "./rbs-information.vue?vue&type=script&setup=true&lang=js"
export * from "./rbs-information.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./rbs-information.vue?vue&type=style&index=0&id=a9884d26&lang=scss&module=true"
cssModules["$style"] = style0
if (module.hot) {
  module.hot.accept("./rbs-information.vue?vue&type=style&index=0&id=a9884d26&lang=scss&module=true", () => {
    cssModules["$style"] = style0
    __VUE_HMR_RUNTIME__.rerender("a9884d26")
  })
}

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__file',"resources/js/common/shared/components/rbs-information.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a9884d26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a9884d26', __exports__)) {
    api.reload('a9884d26', __exports__)
  }
  
  module.hot.accept("./rbs-information.vue?vue&type=template&id=a9884d26", () => {
    api.rerender('a9884d26', render)
  })

}


export default __exports__